import React, { useEffect, useState, useMemo } from 'react'
import OrderlikeLayout from '../../../../generic/Layouts/OrderlikeLayout'
import ControlSearchPannelLayout from '../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import DatePickerModule from '../../../../generic/datePicker/datePicker'
import SearchInput from '../../../../generic/inputs/inputSearch';
import { Mlai } from '../../../../modules/API/Mlai/mlai';
import { ITitleMlaiItem } from '../../../../modules/API/Mlai/models/title';
import BodyScrollContainer from '../../../../generic/Layouts/Wrappers/BodyScrollContainer';
import TitlesList from '../../../../generic/titlesRowItem/TitlesList';
import MlaiTitleItem from './Components/MlaiTitleItem';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { LINKS, relPath } from '../../../../Routs/config';
import MlaiEditMain from './Edit/MlaiEditMain';
import ControlButton from '../../../../generic/buttons/ControlButton';
import { useDispatch } from 'react-redux';
import { LOAD, LOAD_END } from '../../../../../store/actions/actionsTypes';
import Index from './Create/Index';
import ButtonLayout from '../knisot/Layouts/ButtonLayout';
import useDataFetcher from '../knisot/hooks/useFetchData';
import { format } from 'date-fns';

export default function MlaiSectionMain() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    // const [mlaiList, setMlaiList] = useState<ITitleMlaiItem[]>([]); 
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [inputSearchMlai, setInputSearchMlai] = useState('');

    
    const {
        data: mlaiList,
        setData: setMlaiList
    } = useDataFetcher<ITitleMlaiItem[]>(
        Mlai.getMlaiList,
       startDate && endDate ? `DateFrom=${startDate}&DateTo=${endDate}` : ''
    )
    const handleDeleteTitle = async (id: number) => {
        if(!mlaiList) return
        try {
            await Mlai.deleteTitleItem(id)
            const newArr = mlaiList.filter(item => item.CodeStock !== id)
            setMlaiList(newArr)
        } catch (error) {
            
        }
    }
    const validateCreateNewMlai = () => {
        if(!mlaiList || mlaiList.length === 0) return true

        const currentDate = format(new Date(), 'yyyyMMdd')
        const hasTitleForToday = mlaiList.some(item => item.DateStock === currentDate)
        return !hasTitleForToday
    }
    const render = useMemo(() => {
        if(!mlaiList) return []
        return mlaiList.filter(item => 
            item.Remarks.toString().includes(inputSearchMlai) ||
                item.DateStock.trim().includes(inputSearchMlai)
        )
    }, [mlaiList, inputSearchMlai])

    const handleSelectForEdit = (id: number, type: number) => {
        navigate(`${LINKS.mlai.mlai.mainURL}/create/${type === 0 ? 'draft' : 'scan'}/${id}`)
    }
    const handleCreateNewMlai = (id: string) => {
        navigate(LINKS.mlai.mlai.mainURL + `/create/${id}/0`)
    }

    const titleProps = {
        handleSelectForEdit: handleSelectForEdit,
        handleDelete: handleDeleteTitle
    }
  

    return (
        <Routes>
        <Route index element={
            <OrderlikeLayout label='ספירות מלאי' >
                <ControlSearchPannelLayout>
                    <DatePickerModule 
                        multyDate
                        setSelectedDateStart={setStartDate}
                        defEndDate={false}
                        setSelectedDateEnd={setEndDate}
                        selected={false}
                        ignorBrod={true}
                        disabled={false}
                        large
                    />
                    <SearchInput 
                        input={inputSearchMlai}
                        setInput={setInputSearchMlai}
                    />
                </ControlSearchPannelLayout>
                <BodyScrollContainer>
                    <TitlesList 
                        list={render}
                        Element={MlaiTitleItem}
                        uniqueKey={'RecID'}
                        noPadding={false}
                        additionalData={titleProps}
                    />
                </BodyScrollContainer>
                {
                    validateCreateNewMlai() && (
                    <ButtonLayout>
                        <ControlButton
                            lable={' חדש לפי סריקה '}
                            handleClick={() => handleCreateNewMlai('scan')}
                        />
                        <ControlButton
                            lable={'חדש'}
                            handleClick={() => handleCreateNewMlai('draft')}
                        />
    
                    </ButtonLayout>
                    )
                }

            </OrderlikeLayout>
        }/>
        <Route path={relPath(LINKS.mlai.mlai.create, LINKS.mlai.mlai.mainURL)} element={<Index/>} />
        <Route path={relPath(LINKS.mlai.mlai.editGeneral, LINKS.mlai.mlai.mainURL)} element={<MlaiEditMain/>} />
        </Routes>
    )
}
